export enum CAMPAIGN_AD_GROUP {
    PLATFORM = 'platform',
    DELIVERABLES = 'deliverables',
    ASSET_TYPE = 'assest_type',
    SIZE = 'size',
}

export enum Scheduler {
    CC = 'cloud_campaign',
    SMARTER_QUEUE = 'smarter_queue',
    VISTA_SOCIAL = 'vista_social',
}
